import React from 'react';
import { Box } from '@mui/material';

interface Props {
  color?: string;
  height?: number;
  opacity?: string;
  sx?: object;
  width?: number;
}

const Dots4x122Graphic = ({
  color = '#44B3B7',
  height = 65,
  opacity = '.4',
  sx,
  width = 600,
}: Props) => (
  <Box sx={sx}>
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 570 54"
      width={width}
      height={height}
    >
      <g id="Group_5450" className="cls-2">
        <g id="Group_5449">
          <g id="Group_2787">
            <circle id="Ellipse_27" cx="8" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30" cx="8" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28" cx="15" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29" cx="15" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-2">
            <circle id="Ellipse_27-2" cx="22" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-2" cx="22" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-2" cx="29" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-2" cx="29" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-3">
            <circle id="Ellipse_27-3" cx="36" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-3" cx="36" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-3" cx="43" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-3" cx="43" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-4">
            <circle id="Ellipse_27-4" cx="50" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-4" cx="50" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-4" cx="57" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-4" cx="57" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-5">
            <circle id="Ellipse_27-5" cx="64" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-5" cx="64" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-5" cx="71" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-5" cx="71" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-6">
            <circle id="Ellipse_27-6" cx="78" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-6" cx="78" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-6" cx="85" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-6" cx="85" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-7">
            <circle id="Ellipse_27-7" cx="92" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-7" cx="92" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-7" cx="99" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-7" cx="99" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-8">
            <circle id="Ellipse_27-8" cx="106" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-8" cx="106" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-8" cx="113" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-8" cx="113" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-9">
            <circle id="Ellipse_27-9" cx="120" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-9" cx="120" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-9" cx="127" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-9" cx="127" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-10">
            <circle id="Ellipse_27-10" cx="134" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-10" cx="134" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-10" cx="141" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-10" cx="141" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-11">
            <circle id="Ellipse_27-11" cx="148" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-11" cx="148" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-11" cx="155" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-11" cx="155" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-12">
            <circle id="Ellipse_27-12" cx="162" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-12" cx="162" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-12" cx="169" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-12" cx="169" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-13">
            <circle id="Ellipse_27-13" cx="176" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-13" cx="176" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-13" cx="183" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-13" cx="183" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-14">
            <circle id="Ellipse_27-14" cx="190" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-14" cx="190" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-14" cx="197" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-14" cx="197" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-15">
            <circle id="Ellipse_27-15" cx="204" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-15" cx="204" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-15" cx="211" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-15" cx="211" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-16">
            <circle id="Ellipse_27-16" cx="218" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-16" cx="218" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-16" cx="225" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-16" cx="225" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-17">
            <circle id="Ellipse_27-17" cx="232" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-17" cx="232" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-17" cx="239" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-17" cx="239" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-18">
            <circle id="Ellipse_27-18" cx="246" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-18" cx="246" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-18" cx="253" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-18" cx="253" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-19">
            <circle id="Ellipse_27-19" cx="260" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-19" cx="260" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-19" cx="267" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-19" cx="267" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-20">
            <circle id="Ellipse_27-20" cx="274" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-20" cx="274" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-20" cx="281" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-20" cx="281" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-21">
            <circle id="Ellipse_27-21" cx="288" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-21" cx="288" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-21" cx="295" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-21" cx="295" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-22">
            <circle id="Ellipse_27-22" cx="302" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-22" cx="302" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-22" cx="309" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-22" cx="309" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-23">
            <circle id="Ellipse_27-23" cx="316" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-23" cx="316" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-23" cx="323" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-23" cx="323" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-24">
            <circle id="Ellipse_27-24" cx="330" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-24" cx="330" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-24" cx="337" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-24" cx="337" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-25">
            <circle id="Ellipse_27-25" cx="344" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-25" cx="344" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-25" cx="351" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-25" cx="351" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-26">
            <circle id="Ellipse_27-26" cx="358" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-26" cx="358" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-26" cx="365" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-26" cx="365" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-27">
            <circle id="Ellipse_27-27" cx="372" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-27" cx="372" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-27" cx="379" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-27" cx="379" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-28">
            <circle id="Ellipse_27-28" cx="386" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-28" cx="386" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-28" cx="393" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-28" cx="393" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-29">
            <circle id="Ellipse_27-29" cx="400" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-29" cx="400" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-29" cx="407" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-29" cx="407" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-30">
            <circle id="Ellipse_27-30" cx="414" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-30" cx="414" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-30" cx="421" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-30" cx="421" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-31">
            <circle id="Ellipse_27-31" cx="428" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-31" cx="428" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-31" cx="435" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-31" cx="435" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-32">
            <circle id="Ellipse_27-32" cx="442" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-32" cx="442" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-32" cx="449" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-32" cx="449" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-33">
            <circle id="Ellipse_27-33" cx="456" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-33" cx="456" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-33" cx="463" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-33" cx="463" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-34">
            <circle id="Ellipse_27-34" cx="470" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-34" cx="470" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-34" cx="477" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-34" cx="477" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-35">
            <circle id="Ellipse_27-35" cx="484" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-35" cx="484" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-35" cx="491" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-35" cx="491" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-36">
            <circle id="Ellipse_27-36" cx="498" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-36" cx="498" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-36" cx="505" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-36" cx="505" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-37">
            <circle id="Ellipse_27-37" cx="512" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-37" cx="512" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-37" cx="519" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-37" cx="519" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-38">
            <circle id="Ellipse_27-38" cx="526" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-38" cx="526" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-38" cx="533" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-38" cx="533" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-39">
            <circle id="Ellipse_27-39" cx="540" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-39" cx="540" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-39" cx="547" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-39" cx="547" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-40">
            <circle id="Ellipse_27-40" cx="554" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-40" cx="554" cy="16.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-40" cx="561" cy="9.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-40" cx="561" cy="16.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-41">
            <circle id="Ellipse_27-41" cx="8" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-41" cx="8" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-41" cx="15" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-41" cx="15" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-42">
            <circle id="Ellipse_27-42" cx="22" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-42" cx="22" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-42" cx="29" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-42" cx="29" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-43">
            <circle id="Ellipse_27-43" cx="36" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-43" cx="36" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-43" cx="43" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-43" cx="43" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-44">
            <circle id="Ellipse_27-44" cx="50" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-44" cx="50" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-44" cx="57" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-44" cx="57" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-45">
            <circle id="Ellipse_27-45" cx="64" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-45" cx="64" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-45" cx="71" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-45" cx="71" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-46">
            <circle id="Ellipse_27-46" cx="78" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-46" cx="78" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-46" cx="85" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-46" cx="85" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-47">
            <circle id="Ellipse_27-47" cx="92" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-47" cx="92" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-47" cx="99" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-47" cx="99" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-48">
            <circle id="Ellipse_27-48" cx="106" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-48" cx="106" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-48" cx="113" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-48" cx="113" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-49">
            <circle id="Ellipse_27-49" cx="120" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-49" cx="120" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-49" cx="127" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-49" cx="127" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-50">
            <circle id="Ellipse_27-50" cx="134" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-50" cx="134" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-50" cx="141" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-50" cx="141" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-51">
            <circle id="Ellipse_27-51" cx="148" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-51" cx="148" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-51" cx="155" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-51" cx="155" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-52">
            <circle id="Ellipse_27-52" cx="162" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-52" cx="162" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-52" cx="169" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-52" cx="169" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-53">
            <circle id="Ellipse_27-53" cx="176" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-53" cx="176" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-53" cx="183" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-53" cx="183" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-54">
            <circle id="Ellipse_27-54" cx="190" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-54" cx="190" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-54" cx="197" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-54" cx="197" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-55">
            <circle id="Ellipse_27-55" cx="204" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-55" cx="204" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-55" cx="211" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-55" cx="211" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-56">
            <circle id="Ellipse_27-56" cx="218" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-56" cx="218" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-56" cx="225" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-56" cx="225" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-57">
            <circle id="Ellipse_27-57" cx="232" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-57" cx="232" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-57" cx="239" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-57" cx="239" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-58">
            <circle id="Ellipse_27-58" cx="246" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-58" cx="246" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-58" cx="253" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-58" cx="253" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-59">
            <circle id="Ellipse_27-59" cx="260" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-59" cx="260" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-59" cx="267" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-59" cx="267" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-60">
            <circle id="Ellipse_27-60" cx="274" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-60" cx="274" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-60" cx="281" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-60" cx="281" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-61">
            <circle id="Ellipse_27-61" cx="288" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-61" cx="288" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-61" cx="295" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-61" cx="295" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-62">
            <circle id="Ellipse_27-62" cx="302" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-62" cx="302" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-62" cx="309" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-62" cx="309" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-63">
            <circle id="Ellipse_27-63" cx="316" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-63" cx="316" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-63" cx="323" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-63" cx="323" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-64">
            <circle id="Ellipse_27-64" cx="330" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-64" cx="330" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-64" cx="337" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-64" cx="337" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-65">
            <circle id="Ellipse_27-65" cx="344" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-65" cx="344" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-65" cx="351" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-65" cx="351" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-66">
            <circle id="Ellipse_27-66" cx="358" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-66" cx="358" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-66" cx="365" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-66" cx="365" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-67">
            <circle id="Ellipse_27-67" cx="372" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-67" cx="372" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-67" cx="379" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-67" cx="379" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-68">
            <circle id="Ellipse_27-68" cx="386" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-68" cx="386" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-68" cx="393" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-68" cx="393" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-69">
            <circle id="Ellipse_27-69" cx="400" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-69" cx="400" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-69" cx="407" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-69" cx="407" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-70">
            <circle id="Ellipse_27-70" cx="414" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-70" cx="414" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-70" cx="421" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-70" cx="421" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-71">
            <circle id="Ellipse_27-71" cx="428" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-71" cx="428" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-71" cx="435" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-71" cx="435" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-72">
            <circle id="Ellipse_27-72" cx="442" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-72" cx="442" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-72" cx="449" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-72" cx="449" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-73">
            <circle id="Ellipse_27-73" cx="456" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-73" cx="456" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-73" cx="463" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-73" cx="463" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-74">
            <circle id="Ellipse_27-74" cx="470" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-74" cx="470" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-74" cx="477" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-74" cx="477" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-75">
            <circle id="Ellipse_27-75" cx="484" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-75" cx="484" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-75" cx="491" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-75" cx="491" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-76">
            <circle id="Ellipse_27-76" cx="498" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-76" cx="498" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-76" cx="505" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-76" cx="505" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-77">
            <circle id="Ellipse_27-77" cx="512" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-77" cx="512" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-77" cx="519" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-77" cx="519" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-78">
            <circle id="Ellipse_27-78" cx="526" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-78" cx="526" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-78" cx="533" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-78" cx="533" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-79">
            <circle id="Ellipse_27-79" cx="540" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-79" cx="540" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-79" cx="547" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-79" cx="547" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-80">
            <circle id="Ellipse_27-80" cx="554" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-80" cx="554" cy="30.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-80" cx="561" cy="23.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-80" cx="561" cy="30.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-81">
            <circle id="Ellipse_27-81" cx="8" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-81" cx="8" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-81" cx="15" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-81" cx="15" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-82">
            <circle id="Ellipse_27-82" cx="22" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-82" cx="22" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-82" cx="29" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-82" cx="29" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-83">
            <circle id="Ellipse_27-83" cx="36" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-83" cx="36" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-83" cx="43" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-83" cx="43" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-84">
            <circle id="Ellipse_27-84" cx="50" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-84" cx="50" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-84" cx="57" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-84" cx="57" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-85">
            <circle id="Ellipse_27-85" cx="64" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-85" cx="64" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-85" cx="71" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-85" cx="71" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-86">
            <circle id="Ellipse_27-86" cx="78" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-86" cx="78" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-86" cx="85" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-86" cx="85" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-87">
            <circle id="Ellipse_27-87" cx="92" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-87" cx="92" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-87" cx="99" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-87" cx="99" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-88">
            <circle id="Ellipse_27-88" cx="106" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-88" cx="106" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-88" cx="113" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-88" cx="113" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-89">
            <circle id="Ellipse_27-89" cx="120" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-89" cx="120" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-89" cx="127" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-89" cx="127" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-90">
            <circle id="Ellipse_27-90" cx="134" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-90" cx="134" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-90" cx="141" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-90" cx="141" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-91">
            <circle id="Ellipse_27-91" cx="148" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-91" cx="148" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-91" cx="155" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-91" cx="155" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-92">
            <circle id="Ellipse_27-92" cx="162" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-92" cx="162" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-92" cx="169" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-92" cx="169" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-93">
            <circle id="Ellipse_27-93" cx="176" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-93" cx="176" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-93" cx="183" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-93" cx="183" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-94">
            <circle id="Ellipse_27-94" cx="190" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-94" cx="190" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-94" cx="197" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-94" cx="197" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-95">
            <circle id="Ellipse_27-95" cx="204" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-95" cx="204" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-95" cx="211" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-95" cx="211" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-96">
            <circle id="Ellipse_27-96" cx="218" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-96" cx="218" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-96" cx="225" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-96" cx="225" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-97">
            <circle id="Ellipse_27-97" cx="232" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-97" cx="232" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-97" cx="239" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-97" cx="239" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-98">
            <circle id="Ellipse_27-98" cx="246" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-98" cx="246" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-98" cx="253" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-98" cx="253" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-99">
            <circle id="Ellipse_27-99" cx="260" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-99" cx="260" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-99" cx="267" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-99" cx="267" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-100">
            <circle id="Ellipse_27-100" cx="274" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-100" cx="274" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-100" cx="281" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-100" cx="281" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-101">
            <circle id="Ellipse_27-101" cx="288" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-101" cx="288" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-101" cx="295" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-101" cx="295" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-102">
            <circle id="Ellipse_27-102" cx="302" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-102" cx="302" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-102" cx="309" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-102" cx="309" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-103">
            <circle id="Ellipse_27-103" cx="316" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-103" cx="316" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-103" cx="323" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-103" cx="323" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-104">
            <circle id="Ellipse_27-104" cx="330" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-104" cx="330" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-104" cx="337" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-104" cx="337" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-105">
            <circle id="Ellipse_27-105" cx="344" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-105" cx="344" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-105" cx="351" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-105" cx="351" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-106">
            <circle id="Ellipse_27-106" cx="358" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-106" cx="358" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-106" cx="365" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-106" cx="365" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-107">
            <circle id="Ellipse_27-107" cx="372" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-107" cx="372" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-107" cx="379" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-107" cx="379" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-108">
            <circle id="Ellipse_27-108" cx="386" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-108" cx="386" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-108" cx="393" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-108" cx="393" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-109">
            <circle id="Ellipse_27-109" cx="400" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-109" cx="400" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-109" cx="407" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-109" cx="407" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-110">
            <circle id="Ellipse_27-110" cx="414" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-110" cx="414" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-110" cx="421" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-110" cx="421" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-111">
            <circle id="Ellipse_27-111" cx="428" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-111" cx="428" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-111" cx="435" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-111" cx="435" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-112">
            <circle id="Ellipse_27-112" cx="442" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-112" cx="442" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-112" cx="449" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-112" cx="449" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-113">
            <circle id="Ellipse_27-113" cx="456" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-113" cx="456" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-113" cx="463" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-113" cx="463" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-114">
            <circle id="Ellipse_27-114" cx="470" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-114" cx="470" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-114" cx="477" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-114" cx="477" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-115">
            <circle id="Ellipse_27-115" cx="484" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-115" cx="484" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-115" cx="491" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-115" cx="491" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-116">
            <circle id="Ellipse_27-116" cx="498" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-116" cx="498" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-116" cx="505" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-116" cx="505" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-117">
            <circle id="Ellipse_27-117" cx="512" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-117" cx="512" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-117" cx="519" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-117" cx="519" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-118">
            <circle id="Ellipse_27-118" cx="526" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-118" cx="526" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-118" cx="533" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-118" cx="533" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-119">
            <circle id="Ellipse_27-119" cx="540" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-119" cx="540" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-119" cx="547" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-119" cx="547" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
          <g id="Group_2787-120">
            <circle id="Ellipse_27-120" cx="554" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_30-120" cx="554" cy="44.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_28-120" cx="561" cy="37.5" r="2" fill={color} opacity={opacity} />
            <circle id="Ellipse_29-120" cx="561" cy="44.5" r="2" fill={color} opacity={opacity} />
          </g>
        </g>
      </g>
    </svg>
  </Box>
);

export default Dots4x122Graphic;
